package com.schoolconnect.app.feature.parents

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntRect
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppDialogColors
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogValidationSummary
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppSearchableDropdownField
import com.schoolconnect.app.designsystem.AppButton
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInfoBg
import com.schoolconnect.app.designsystem.AppInfoBorder
import com.schoolconnect.app.designsystem.AppInfoText
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.repository.systemlookup.SystemLookupRepository
import com.schoolconnect.app.designsystem.list.AdminListFilterBanner
import com.schoolconnect.app.designsystem.list.AdminInfoBanner
import com.schoolconnect.app.designsystem.list.AdminListDefaults
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPagination
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListRowAction
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListToolbar
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.feature.common.compareBySmartText
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.designsystem.list.AdminStandardRowActionMenu
import com.schoolconnect.app.designsystem.list.ListTableCell
import com.schoolconnect.app.designsystem.list.ListTableRowContainer
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.domain.SchoolKeys
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.circle_pause
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.mail
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.phone
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.trash
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource
import androidx.compose.ui.window.Popup
import androidx.compose.ui.window.PopupPositionProvider
import androidx.compose.ui.window.PopupProperties
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlin.math.min

internal val ParentsBackground = AppBackground
internal val ParentsSurface = AppSurface
internal val ParentsBorder = AppBorder
internal val ParentsNavy = AppNavy
internal val ParentsMuted = AppMuted
internal val ParentsPrimary = AppPrimary
internal val ParentsPrimarySoft = AppPrimarySoft
internal val ParentsSuccess = AppSuccess
internal val ParentsSuccessSoft = AppSuccessSoft
internal val ParentsDanger = AppDanger
internal val ParentsDangerSoft = AppDangerSoft
internal val ParentsLine = AppLine
internal val ParentsInfoBg = AppInfoBg
internal val ParentsInfoBorder = AppInfoBorder
internal val ParentsInfoText = AppInfoText
internal val ParentsSelectBg = Color(0xFFF6F8FF)
internal val ParentsDialogColors = com.schoolconnect.app.designsystem.AppDialogDefaultColors


internal data class ParentSelectionResult(
    val items: List<ParentStudentOptionUi> = emptyList(),
    val totalCount: Int = 0
)

internal fun parentsPage(state: ParentsUiState): ParentPageUi {
    // The analytics total is an unfiltered aggregate. Pagination must use the
    // filtered total returned by the list endpoint and stored by the ViewModel.
    val totalCount = state.totalCount
    val window = pageWindow(state.pageIndex, state.pageSize, totalCount)
    val items = state.parents
    val end = if (items.isEmpty()) 0 else min(window.endIndex, totalCount)

    return ParentPageUi(
        items = items,
        totalCount = totalCount,
        startIndex = if (items.isEmpty()) 0 else window.startIndex,
        endIndex = end,
        pageCount = window.pageCount
    )
}

internal fun parentComparator(
    field: ParentSortField,
    ascending: Boolean
): Comparator<ParentRowUi> {
    val comparator = when (field) {
        ParentSortField.ADMISSION_NO -> compareBySmartText<ParentRowUi> { it.admissionNo }
        ParentSortField.STUDENT_DETAILS -> compareBySmartText<ParentRowUi> {
            val student = parentPrimaryStudent(it)
            buildStudentDetailsSortLabel(student)
        }
        ParentSortField.PRIMARY_CONTACT_NAME -> compareBySmartText<ParentRowUi> { it.primaryContactName }
        ParentSortField.PRIMARY_CONTACT_MOBILE -> compareBySmartText<ParentRowUi> { it.primaryContactMobile }
        ParentSortField.RELATIONSHIP -> compareBySmartText<ParentRowUi> { parentRelationshipLabel(parentPrimaryRelationshipCode(it)) }
    }
    return if (ascending) comparator else comparator.reversed()
}

internal fun parentPrimaryStudent(parent: ParentRowUi): ParentLinkedStudentUi? =
    parent.linkedStudents.firstOrNull { it.isPrimaryContact } ?: parent.linkedStudents.firstOrNull()

internal fun parentPrimaryRelationshipCode(parent: ParentRowUi): String {
    val linkedRelationship = parentPrimaryStudent(parent)?.relationshipType.orEmpty().trim()
    return linkedRelationship.ifBlank {
        parent.primaryRelationshipCode.trim()
    }
}

internal fun parentRelationshipLabel(code: String): String = when (code) {
    SchoolKeys.V_REL_FATHER -> "Father"
    SchoolKeys.V_REL_MOTHER -> "Mother"
    SchoolKeys.V_REL_GUARDIAN -> "Guardian"
    else -> when (code.trim().lowercase()) {
        "father" -> "Father"
        "mother" -> "Mother"
        "guardian" -> "Guardian"
        else -> code.trim().ifBlank { "-" }.replaceFirstChar { ch ->
            if (ch.isLowerCase()) ch.titlecase() else ch.toString()
        }
    }
}

internal fun parentStatusLabel(code: String): String = when (code) {
    SchoolKeys.V_STATUS_ACTIVE -> "Active"
    SchoolKeys.V_STATUS_INACTIVE -> "Inactive"
    else -> code.ifBlank { "-" }
}

internal fun parentDisplayName(parent: ParentRowUi): String =
    "${parent.primaryContactName}".trim().ifBlank { parent.studentName }

internal fun parentStudentLabel(parent: ParentRowUi): String =
    parentPrimaryStudent(parent)?.let { student ->
        buildStudentDetailsLabel(student)
    } ?: "-"

internal fun parentPrimarySummary(parent: ParentRowUi): String =
    listOf(
        parent.primaryContactName.ifBlank { "-" },
        parentRelationshipLabel(parentPrimaryRelationshipCode(parent)),
        parent.primaryContactMobile.ifBlank { "-" },
        parent.primaryContactEmail.ifBlank { "-" }
    ).joinToString(" | ")

internal fun parentSecondarySummary(parent: ParentRowUi): String {
    val hasSecondaryContact = listOf(
        parent.secondaryContactName,
        parent.secondaryContactMobile,
        parent.secondaryContactEmail,
        parent.secondaryRelationshipCode
    ).any { it.isNotBlank() }
    if (!hasSecondaryContact) return "Secondary Contact information not available"

    return listOf(
        parent.secondaryContactName.ifBlank { "-" },
        parentRelationshipLabel(parent.secondaryRelationshipCode),
        parent.secondaryContactMobile.ifBlank { "-" },
        parent.secondaryContactEmail.ifBlank { "-" }
    ).joinToString(" | ")
}

private fun buildStudentDetailsSortLabel(student: ParentLinkedStudentUi?): String {
    if (student == null) return ""
    return listOf(
        student.className.ifBlank { "-" },
        student.section.ifBlank { "-" },
        student.studentName.ifBlank { "-" }
    ).joinToString(" ")
}

private fun buildStudentDetailsLabel(student: ParentLinkedStudentUi): String {
    val classSection = buildClassSectionLabel(student.className, student.section).ifBlank { "-" }
    val studentName = student.studentName.ifBlank { "-" }
    return if (classSection == "-" && studentName == "-") "-" else "$classSection | $studentName"
}

internal fun matchesDateFilter(rowValue: String, filterValue: String, lowerBound: Boolean): Boolean {
    val parsed = parseDateInput(filterValue) ?: return true
    val rowParsed = parseDateInput(rowValue) ?: return false
    return if (lowerBound) rowParsed >= parsed else rowParsed <= parsed
}

private fun parseDateInput(value: String): Long? {
    val trimmed = value.trim()
    if (trimmed.isBlank()) return null
    parseSlashOrDashDate(trimmed)?.let { return it }

    val tokens = trimmed.replace(",", " ").split(Regex("\\s+")).filter { it.isNotBlank() }
    if (tokens.size < 3) return null
    val day = tokens[0].toIntOrNull() ?: return null
    val month = when (tokens[1].lowercase().take(3)) {
        "jan" -> 1
        "feb" -> 2
        "mar" -> 3
        "apr" -> 4
        "may" -> 5
        "jun" -> 6
        "jul" -> 7
        "aug" -> 8
        "sep" -> 9
        "oct" -> 10
        "nov" -> 11
        "dec" -> 12
        else -> return null
    }
    val year = tokens[2].toIntOrNull() ?: return null
    return (year * 10_000L) + (month * 100L) + day
}

private fun parseSlashOrDashDate(value: String): Long? {
    val separator = when {
        value.contains('/') -> '/'
        value.contains('-') -> '-'
        else -> return null
    }
    val parts = value.split(separator).map { it.trim() }
    if (parts.size != 3) return null
    val day = parts[0].toIntOrNull() ?: return null
    val month = parts[1].toIntOrNull() ?: return null
    val year = parts[2].toIntOrNull() ?: return null
    if (day !in 1..31 || month !in 1..12) return null
    return (year * 10_000L) + (month * 100L) + day
}

@Composable
internal fun ParentsScreenContent(
    state: ParentsUiState,
    onEvent: (ParentsUiEvent) -> Unit,
    headerActions: @Composable RowScope.() -> Unit = {}
) {
    val page = parentsPage(state)
    val pageText = if (page.totalCount == 0) {
        "Showing 0 to 0 of 0 records"
    } else {
        "Showing ${page.startIndex} to ${page.endIndex} of ${page.totalCount} records"
    }

    var showEditorDialog by remember { mutableStateOf(false) }
    var showFilterDialog by remember { mutableStateOf(false) }
    var showDetailsDialog by remember { mutableStateOf<ParentRowUi?>(null) }
    var editorDraft by remember { mutableStateOf(ParentEditorDraft()) }
    var filterDraft by remember { mutableStateOf(state.filters) }
    var rowsPerPageExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(state.mutationSuccessNonce) {
        if (state.mutationSuccessNonce > 0L) showEditorDialog = false
    }

    AdminListPageScaffold(
        title = "Manage Parents",
        subtitle = "Create, update and manage parent contact records.",
        backgroundColor = ParentsBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        headerActions = headerActions,
        summaryCards = {},
        showSummaryCards = false,
        bannerAfterToolbar = true,
        banner = {
            val filters = parentFilterLabels(state.filters)
            if (!showEditorDialog) {
                val hasMessage = state.errorMessage.isNotBlank() ||
                    state.infoMessage.isNotBlank() || state.filterLookupError.isNotBlank()
                if (hasMessage) {
                    ParentBanner(
                        message = state.errorMessage.ifBlank { state.filterLookupError }.ifBlank { state.infoMessage },
                        isError = state.errorMessage.isNotBlank() || state.filterLookupError.isNotBlank(),
                        onDismiss = { onEvent(ParentsUiEvent.ClearMessages) }
                    )
                }
                AdminListFilterBanner(
                    chips = filters,
                    onClearAll = { onEvent(ParentsUiEvent.FiltersReset) },
                    onRemoveChip = { chip ->
                        val next = when {
                            chip.startsWith("Parent:") -> state.filters.copy(parentName = "")
                            chip.startsWith("Student:") -> state.filters.copy(studentQuery = "")
                            chip.startsWith("Class:") || chip.startsWith("Section:") -> state.filters.copy(classSectionId = "", className = "", section = "")
                            chip.startsWith("Primary relation:") -> state.filters.copy(primaryRelationshipCode = "")
                            chip.startsWith("Secondary relation:") -> state.filters.copy(secondaryRelationshipCode = "")
                            chip.startsWith("Mobile:") -> state.filters.copy(mobile = "")
                            chip.startsWith("Created:") -> state.filters.copy(createdFrom = "", createdTo = "")
                            else -> state.filters
                        }
                        onEvent(ParentsUiEvent.FiltersApplied(next))
                    },
                    onEditFilters = { showFilterDialog = true },
                    backgroundColor = Color(0xFFF2F7FF),
                    borderColor = ParentsBorder,
                    contentColor = ParentsNavy,
                    accentColor = ParentsPrimary
                )
            }
        },
        toolbar = {
            AdminListToolbar(
                searchQuery = state.searchQuery,
                onSearchQueryChanged = { onEvent(ParentsUiEvent.SearchChanged(it)) },
                searchPlaceholder = "Search by admission no, parent or student...",
                searchWidth = 320.dp,
                surfaceColor = ParentsSurface,
                borderColor = ParentsBorder,
                searchIconTint = ParentsMuted,
                searchTextColor = ParentsNavy,
                searchCursorColor = ParentsPrimary,
                inlineContent = {
                    val classSectionOptions = remember(state.filterClassSectionOptions) {
                        state.filterClassSectionOptions.distinctBy { it.id }
                    }
                    AppSearchableDropdownField(
                        label = "",
                        value = classSectionOptions.firstOrNull { it.id == state.filters.classSectionId }?.label.orEmpty(),
                        placeholder = "Select Class / Section",
                        options = classSectionOptions.map { it.label },
                        onValueChange = { choiceLabel ->
                            val choice = classSectionOptions.firstOrNull { it.label == choiceLabel }
                            onEvent(
                                ParentsUiEvent.FiltersApplied(
                                    state.filters.copy(
                                        classSectionId = choice?.id.orEmpty(),
                                        className = choice?.className.orEmpty(),
                                        section = choice?.sectionName.orEmpty()
                                    )
                                )
                            )
                        },
                        modifier = Modifier.width(240.dp),
                        valueFontWeight = androidx.compose.ui.text.font.FontWeight.Normal,
                        maxMenuHeight = 320.dp
                    )
                }
            ) {
                AdminListToolbarButton(
                    label = "More Filters",
                    icon = painterResource(Res.drawable.filter),
                    onClick = {
                        filterDraft = state.filters
                        showFilterDialog = true
                    },
                    width = 148.dp,
                    borderColor = ParentsBorder,
                    contentColor = ParentsPrimary
                )
                AdminListToolbarButton(
                    label = "Clear",
                    icon = painterResource(Res.drawable.close_x),
                    onClick = { onEvent(ParentsUiEvent.FiltersReset) },
                    width = 100.dp,
                    borderColor = ParentsBorder,
                    contentColor = ParentsPrimary
                )
            }
        },
        table = { tableModifier ->
            AdminListTableCard(
                modifier = tableModifier,
                surfaceColor = ParentsSurface,
                borderColor = ParentsBorder,
                minContentWidth = 900.dp,
                header = {
                    AdminListSortHeaderRow(
                        columns = listOf(
                            AdminListSortColumn("Admission No", 1.0f, state.sortField == ParentSortField.ADMISSION_NO, state.isSortAscending) {
                                onEvent(ParentsUiEvent.SortChanged(ParentSortField.ADMISSION_NO))
                            },
                            AdminListSortColumn("Student Details", 1.45f, state.sortField == ParentSortField.STUDENT_DETAILS, state.isSortAscending) {
                                onEvent(ParentsUiEvent.SortChanged(ParentSortField.STUDENT_DETAILS))
                            },
                            AdminListSortColumn("Primary Contact Name", 1.4f, state.sortField == ParentSortField.PRIMARY_CONTACT_NAME, state.isSortAscending) {
                                onEvent(ParentsUiEvent.SortChanged(ParentSortField.PRIMARY_CONTACT_NAME))
                            },
                            AdminListSortColumn("Primary Contact Mobile", 1.25f, state.sortField == ParentSortField.PRIMARY_CONTACT_MOBILE, state.isSortAscending) {
                                onEvent(ParentsUiEvent.SortChanged(ParentSortField.PRIMARY_CONTACT_MOBILE))
                            },
                            AdminListSortColumn("Relationship", 0.9f, state.sortField == ParentSortField.RELATIONSHIP, state.isSortAscending) {
                                onEvent(ParentsUiEvent.SortChanged(ParentSortField.RELATIONSHIP))
                            },
                        ),
                        actionsWeight = 0.8f,
                        actionsAlignment = Alignment.Center,
                        horizontalPadding = 22.dp
                    )
                },
                body = {
                    if (state.isPageLoading) {
                        AdminListTableShimmer(
                            columns = parentsTableShimmerColumns(),
                            rowCount = state.pageSize.coerceAtLeast(5),
                            modifier = Modifier.fillMaxWidth(),
                            surfaceColor = ParentsSurface,
                            borderColor = ParentsBorder,
                            horizontalPadding = 16.dp,
                            cellHorizontalPadding = 6.dp
                        )
                    } else if (page.items.isEmpty()) {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .weight(1f),
                            contentAlignment = Alignment.Center
                        ) {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                Text(
                                    text = "No parents found",
                                    style = MaterialTheme.typography.titleMedium,
                                    color = ParentsNavy,
                                    fontWeight = FontWeight.SemiBold
                                )
                                Spacer(modifier = Modifier.height(6.dp))
                                Text(
                                    text = "Try a different search or filter.",
                                    style = MaterialTheme.typography.bodyMedium,
                                    color = ParentsMuted
                                )
                            }
                        }
                    } else {
                        AdminListTableBody(
                            modifier = Modifier
                                .fillMaxWidth()
                                .weight(1f),
                            items = page.items,
                            key = { it.studentId.ifBlank { it.id } }
                        ) { parent ->
                            ParentTableRow(
                                parent = parent,
                                onView = { showDetailsDialog = parent },
                                onEdit = {
                                    editorDraft = parent.toEditorDraft()
                                    onEvent(ParentsUiEvent.ParentEditorDismissed)
                                    showEditorDialog = true
                                },
                            )
                            }
                    }
                },
                footer = {
                    AdminListFooter(
                        pageText = pageText,
                        pageIndex = state.pageIndex,
                        pageCount = page.pageCount,
                        onPageChanged = { onEvent(ParentsUiEvent.PageChanged(it)) },
                        pageSize = state.pageSize,
                        rowsPerPageExpanded = rowsPerPageExpanded,
                        onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded },
                        onRowsPerPageDismiss = { rowsPerPageExpanded = false },
                        onPageSizeChanged = { onEvent(ParentsUiEvent.PageSizeChanged(it)) },
                        footerColor = ParentsMuted,
                        borderColor = ParentsBorder,
                        surfaceColor = ParentsSurface,
                        primaryColor = ParentsPrimary,
                        navyColor = ParentsNavy,
                        mutedColor = ParentsMuted
                    )
                }
            )
        },
        bottomAction = {
            AdminListPrimaryActionButton(
                label = "Add Parent",
                icon = painterResource(Res.drawable.plus),
                onClick = {
                    editorDraft = ParentEditorDraft()
                    onEvent(ParentsUiEvent.ParentEditorDismissed)
                    showEditorDialog = true
                },
                modifier = Modifier.width(180.dp),
                backgroundColor = ParentsPrimary
            )
        }
    )

    if (showEditorDialog) {
        ParentEditorDialog(
            draft = editorDraft,
            studentOptions = state.studentOptions,
            studentPickerQuery = state.studentPickerQuery,
            studentPickerIsLoading = state.studentPickerIsLoading,
            studentPickerIsLoadingMore = state.studentPickerIsLoadingMore,
            studentPickerHasMore = state.studentPickerHasMore,
            studentPickerError = state.studentPickerError,
            onStudentPickerOpened = { onEvent(ParentsUiEvent.StudentPickerOpened) },
            onStudentPickerSearchChanged = { onEvent(ParentsUiEvent.StudentPickerSearchChanged(it)) },
            onStudentPickerLoadMore = { onEvent(ParentsUiEvent.StudentPickerLoadMore) },
            onDraftChange = { editorDraft = it },
            isSaving = state.isSaving,
            apiError = state.apiErrorMessage,
            onDismiss = {
                if (!state.isSaving) {
                    showEditorDialog = false
                    onEvent(ParentsUiEvent.ParentEditorDismissed)
                }
            },
            onSave = {
                onEvent(ParentsUiEvent.SaveParent(it))
            }
        )
    }

    if (showFilterDialog) {
        ParentFilterDialog(
            draft = filterDraft,
            classOptions = state.filterClassOptions,
            sectionsByClass = state.filterSectionsByClass,
            onDraftChange = { filterDraft = it },
            onDismiss = { showFilterDialog = false },
            onApply = {
                onEvent(ParentsUiEvent.FiltersApplied(it.copy(parentName = "", studentQuery = "", mobile = "")))
                showFilterDialog = false
            },
            onReset = {
                filterDraft = ParentFilterCriteria()
                onEvent(ParentsUiEvent.FiltersReset)
            }
        )
    }

    showDetailsDialog?.let { parent ->
        ParentDetailsDialog(
            parent = parent,
            onDismiss = { showDetailsDialog = null }
        )
    }

}

@Composable
private fun ParentTableRow(
    parent: ParentRowUi,
    onView: () -> Unit,
    onEdit: () -> Unit,
) {
    ListTableRowContainer(
        modifier = Modifier.fillMaxWidth().onViewDoubleClick(onView)
    ) {
        ListTableCell(parent.admissionNo, 1.0f)
        ParentStudentCell(parent, 1.45f)
        ListTableCell(parent.primaryContactName, 1.4f)
        ListTableCell(parent.primaryContactMobile, 1.25f)
        ListTableCell(parentRelationshipLabel(parentPrimaryRelationshipCode(parent)), 0.9f)
        ParentRowMenu(onView = onView, onEdit = onEdit, actionsWeight = 0.8f)
    }
}

@Composable
private fun RowScope.ParentStudentCell(parent: ParentRowUi, weight: Float) {
    Column(
        modifier = Modifier
            .weight(weight)
            .padding(horizontal = 6.dp),
        verticalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        AdminListTableBodyText(
            text = parentStudentLabel(parent),
            color = ParentsNavy,
            modifier = Modifier.fillMaxWidth()
        )
        if (parent.linkedStudents.size > 1) {
            AdminListTableBodyText(
                text = "+${parent.linkedStudents.size - 1} more",
                color = ParentsPrimary,
                fontWeight = FontWeight.SemiBold,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}

@Composable
private fun ParentStatusBadge(
    statusCode: String,
    modifier: Modifier = Modifier
) {
    val active = statusCode == SchoolKeys.V_STATUS_ACTIVE
    val fg = if (active) ParentsSuccess else ParentsDanger
    AdminListTableBodyText(
        text = parentStatusLabel(statusCode),
        color = fg,
        modifier = modifier
    )
}

private fun parentsTableShimmerColumns(): List<AdminListHeaderColumn> = listOf(
    AdminListHeaderColumn("Admission No", 1.0f),
    AdminListHeaderColumn("Student Details", 1.45f),
    AdminListHeaderColumn("Primary Contact Name", 1.4f),
    AdminListHeaderColumn("Primary Contact Mobile", 1.25f),
    AdminListHeaderColumn("Relationship", 0.9f),
    AdminListHeaderColumn("Actions", 0.8f, alignCenter = true)
)

@Composable
private fun RowScope.ParentRowMenu(
    onView: () -> Unit,
    onEdit: () -> Unit,
    actionsWeight: Float
) {
    Row(
        modifier = Modifier.weight(actionsWeight),
        horizontalArrangement = Arrangement.spacedBy(2.dp, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically
    ) {
        androidx.compose.material3.IconButton(onClick = onView, modifier = Modifier.size(32.dp)) {
            Icon(painterResource(Res.drawable.eye), contentDescription = "View parent", tint = ParentsNavy, modifier = Modifier.size(16.dp))
        }
        androidx.compose.material3.IconButton(onClick = onEdit, modifier = Modifier.size(32.dp)) {
            Icon(painterResource(Res.drawable.pencil), contentDescription = "Edit parent", tint = ParentsNavy, modifier = Modifier.size(16.dp))
        }
    }
}

@Composable
private fun ParentBanner(
    message: String,
    isError: Boolean,
    onDismiss: () -> Unit
) {
    val bg = if (isError) ParentsDangerSoft else ParentsInfoBg
    val border = if (isError) ParentsDanger.copy(alpha = 0.35f) else ParentsInfoBorder
    val fg = if (isError) ParentsDanger else ParentsInfoText
    AdminInfoBanner(
        message = message,
        onDismiss = onDismiss,
        backgroundColor = bg,
        borderColor = border,
        contentColor = fg,
        accentColor = fg,
        isError = isError
    )
}

@Composable
private fun rememberParentRelationshipOptions(): List<Pair<String, String>> {
    var options by remember { mutableStateOf(emptyList<Pair<String, String>>()) }
    LaunchedEffect(Unit) {
        options = SystemLookupRepository.loadCategoryItems("PARENT_RELATIONSHIP")
            .getOrDefault(emptyList())
            .mapNotNull { item ->
                val code = item.code?.trim().orEmpty()
                val label = item.displayValue?.trim().takeUnless { it.isNullOrBlank() } ?: code
                code.takeIf { it.isNotBlank() }?.let { it to label }
            }
            .distinctBy { it.first.uppercase() }
    }
    return options
}

@Composable
private fun ParentFilterDialog(
    draft: ParentFilterCriteria,
    classOptions: List<String>,
    sectionsByClass: Map<String, List<String>>,
    onDraftChange: (ParentFilterCriteria) -> Unit,
    onDismiss: () -> Unit,
    onApply: (ParentFilterCriteria) -> Unit,
    onReset: () -> Unit
) {
    val relationshipOptions = rememberParentRelationshipOptions()
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        colors = ParentsDialogColors
    ) {
        AppDialogHeader(
            title = "Filter Parents",
            subtitle = "Narrow down the parent list.",
            onClose = onDismiss,
            colors = ParentsDialogColors,
            height = 112.dp,
            icon = Res.drawable.filter,
            iconContentDescription = "Filter parents"
        )
        HorizontalDivider(color = ParentsLine)
        AppDialogBody(
            colors = ParentsDialogColors,
            horizontalPadding = 24.dp,
            compactHorizontalPadding = 20.dp,
            verticalPadding = 18.dp
        ) { _ ->
            Column(verticalArrangement = Arrangement.spacedBy(18.dp)) {
                DualFilterRow(
                    left = {
                        ParentDropdownField(
                            label = "Class",
                            value = draft.className.ifBlank { "Select Class" },
                            items = classOptions,
                            onSelected = { onDraftChange(draft.copy(classSectionId = "", className = it, section = "")) }
                        )
                    },
                    right = {
                        ParentDropdownField(
                            label = "Section",
                            value = draft.section.ifBlank { "Select Section" },
                            items = sectionsByClass[draft.className].orEmpty()
                                .ifEmpty { sectionsByClass.values.flatten().distinct() },
                            onSelected = { onDraftChange(draft.copy(classSectionId = "", section = it)) }
                        )
                    }
                )
                DualFilterRow(
                    left = {
                        ParentDropdownField(
                            label = "Primary Relationship",
                            value = draft.primaryRelationshipCode.ifBlank { "Select Relationship" }.relationshipDisplay(),
                            items = relationshipOptions,
                            onSelected = { onDraftChange(draft.copy(primaryRelationshipCode = it)) }
                        )
                    },
                    right = {
                        ParentDropdownField(
                            label = "Secondary Relationship",
                            value = draft.secondaryRelationshipCode.ifBlank { "Select Relationship" }.relationshipDisplay(),
                            items = relationshipOptions,
                            onSelected = { onDraftChange(draft.copy(secondaryRelationshipCode = it)) }
                        )
                    }
                )
                DualFilterRow(
                    left = {
                        ParentDateField(
                            label = "Created Date From",
                            value = draft.createdFrom,
                            placeholder = "DD MMM YYYY",
                            onValueChange = { onDraftChange(draft.copy(createdFrom = it)) }
                        )
                    },
                    right = {
                        ParentDateField(
                            label = "Created Date To",
                            value = draft.createdTo,
                            placeholder = "DD MMM YYYY",
                            onValueChange = { onDraftChange(draft.copy(createdTo = it)) }
                        )
                    }
                )
            }
        }
        HorizontalDivider(color = ParentsLine)
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction(label = "Cancel", onClick = onDismiss, width = 152.dp),
                AppDialogFooterAction(label = "Reset", onClick = onReset, width = 152.dp),
                AppDialogFooterAction(
                    label = "Apply",
                    onClick = { onApply(draft) },
                    style = AppDialogActionStyle.Primary,
                    width = 188.dp
                )
            ),
            colors = ParentsDialogColors,
            contentPadding = PaddingValues(horizontal = 20.dp),
            footerHeight = 80.dp
        )
    }
}

@Composable
private fun ParentEditorDialog(
    draft: ParentEditorDraft,
    studentOptions: List<ParentStudentOptionUi>,
    studentPickerQuery: String,
    studentPickerIsLoading: Boolean,
    studentPickerIsLoadingMore: Boolean,
    studentPickerHasMore: Boolean,
    studentPickerError: String,
    onStudentPickerOpened: () -> Unit,
    onStudentPickerSearchChanged: (String) -> Unit,
    onStudentPickerLoadMore: () -> Unit,
    isSaving: Boolean,
    apiError: String,
    onDraftChange: (ParentEditorDraft) -> Unit,
    onDismiss: () -> Unit,
    onSave: (ParentEditorDraft) -> Unit
) {
    val relationshipOptions = rememberParentRelationshipOptions()
    val selectedStudent = studentOptions.firstOrNull { it.id == draft.selectedStudentId }
    val selectedLabel = selectedStudent?.let {
        "${it.admissionNo} | ${it.studentName} | Class ${it.className}-${it.section} | Roll No. ${it.rollNo}"
    } ?: draft.selectedStudentLabel
    var studentPickerExpanded by remember { mutableStateOf(false) }
    var hasSubmitted by remember(draft.id) { mutableStateOf(draft.id.isNotBlank()) }
    val validation = remember(hasSubmitted, draft) {
        if (hasSubmitted) validateParentEditor(draft) else ParentEditorValidationErrors()
    }

    AppDialogScaffold(
        onDismiss = { if (!isSaving) onDismiss() },
        dismissOnClickOutside = false,
        size = AppDialogSize.Wide,
        colors = ParentsDialogColors,
        fillDialogHeight = true,
        isLoading = isSaving,
        loadingTitle = if (draft.id.isBlank()) "Adding parent" else "Saving parent"
    ) {
        AppDialogHeader(
            title = if (draft.id.isBlank()) "Add Parent" else "Edit Parent",
            subtitle = if (draft.id.isBlank()) {
                "Enter parent details to create a new parent record."
            } else {
                "Update parent/guardian details for this student."
            },
            onClose = { if (!isSaving) onDismiss() },
            colors = ParentsDialogColors,
            height = 96.dp
        )
        AppDialogValidationSummary(
            errors = listOf(validation.student, validation.primaryName, validation.primaryMobile, validation.primaryEmail, validation.secondaryName, validation.secondaryMobile, validation.secondaryEmail),
            colors = ParentsDialogColors,
            modifier = Modifier.padding(horizontal = 24.dp, vertical = 12.dp)
        )
        AppDialogErrorMessage(
            message = apiError,
            colors = ParentsDialogColors,
            modifier = Modifier.padding(horizontal = 24.dp, vertical = 12.dp)
        )
        HorizontalDivider(color = ParentsLine)
        AppDialogBody(
            colors = ParentsDialogColors,
            horizontalPadding = 24.dp,
            compactHorizontalPadding = 18.dp,
            verticalPadding = 18.dp,
            fillAvailable = true
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                ParentStudentSelectorField(
                    label = "Student *",
                    selectedStudentId = draft.selectedStudentId,
                    selectedLabel = selectedLabel,
                    expanded = studentPickerExpanded,
                    query = studentPickerQuery,
                    students = studentOptions,
                    isLoading = studentPickerIsLoading,
                    isLoadingMore = studentPickerIsLoadingMore,
                    hasMore = studentPickerHasMore,
                    loadError = studentPickerError,
                    onStudentPickerLoadMore = onStudentPickerLoadMore,
                    onToggleExpanded = {
                        val willOpen = !studentPickerExpanded
                        studentPickerExpanded = !studentPickerExpanded
                        if (willOpen) onStudentPickerOpened()
                    },
                    onDismissExpanded = { studentPickerExpanded = false },
                    onQueryChange = onStudentPickerSearchChanged,
                    onClearSelection = {
                        onDraftChange(draft.copy(selectedStudentId = "", selectedStudentLabel = "", studentSearchQuery = ""))
                    },
                    onSelectStudent = {
                        onDraftChange(it.toParentEditorDraft(draft))
                        studentPickerExpanded = false
                    },
                    error = validation.student
                )

                if (selectedStudent != null) {
                    SelectedStudentSummary(selectedStudent)
                }

                SectionHeader("Primary Contact Information")

                DualFilterRow(
                    left = {
                        ParentTextField(
                            label = "Primary Contact Name *",
                            value = draft.primaryContactName,
                            placeholder = "Enter primary contact name",
                            leadingIcon = Res.drawable.users,
                            onValueChange = { onDraftChange(draft.copy(primaryContactName = it)) },
                            error = validation.primaryName
                        )
                    },
                    right = {
                        ParentTextField(
                            label = "Primary Contact Mobile *",
                            value = draft.primaryContactMobile,
                            placeholder = "Enter mobile number",
                            leadingIcon = Res.drawable.phone,
                            onValueChange = { onDraftChange(draft.copy(primaryContactMobile = it)) },
                            error = validation.primaryMobile
                        )
                    }
                )

                DualFilterRow(
                    left = {
                        ParentTextField(
                            label = "Primary Contact Email",
                            value = draft.primaryContactEmail,
                            placeholder = "Enter email address",
                            leadingIcon = Res.drawable.mail,
                            onValueChange = { onDraftChange(draft.copy(primaryContactEmail = it)) },
                            error = validation.primaryEmail
                        )
                    },
                    right = {
                        ParentDropdownField(
                            label = "Relationship *",
                            value = parentRelationshipLabel(draft.primaryRelationshipCode),
                            items = relationshipOptions,
                            onSelected = { onDraftChange(draft.copy(primaryRelationshipCode = it)) }
                        )
                    }
                )

                SectionHeader("Secondary Contact Information (Optional)")

                DualFilterRow(
                    left = {
                        ParentTextField(
                            label = "Secondary Contact Name",
                            value = draft.secondaryContactName,
                            placeholder = "Enter secondary contact name",
                            leadingIcon = Res.drawable.users,
                            onValueChange = { onDraftChange(draft.copy(secondaryContactName = it)) },
                            error = validation.secondaryName
                        )
                    },
                    right = {
                        ParentTextField(
                            label = "Secondary Contact Mobile",
                            value = draft.secondaryContactMobile,
                            placeholder = "Enter mobile number",
                            leadingIcon = Res.drawable.phone,
                            onValueChange = { onDraftChange(draft.copy(secondaryContactMobile = it)) },
                            error = validation.secondaryMobile
                        )
                    }
                )

                DualFilterRow(
                    left = {
                        ParentTextField(
                            label = "Secondary Contact Email",
                            value = draft.secondaryContactEmail,
                            placeholder = "Enter email address",
                            leadingIcon = Res.drawable.mail,
                            onValueChange = { onDraftChange(draft.copy(secondaryContactEmail = it)) },
                            error = validation.secondaryEmail
                        )
                    },
                    right = {
                        ParentDropdownField(
                            label = "Relationship",
                            value = parentRelationshipLabel(draft.secondaryRelationshipCode),
                            items = relationshipOptions,
                            onSelected = { onDraftChange(draft.copy(secondaryRelationshipCode = it)) }
                        )
                    }
                )

            }
        }
        HorizontalDivider(color = ParentsLine)
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction(
                    label = "Cancel",
                    onClick = { if (!isSaving) onDismiss() },
                    enabled = !isSaving,
                    width = 132.dp
                ),
                AppDialogFooterAction(
                    label = if (isSaving) {
                        if (draft.id.isBlank()) "Adding..." else "Saving..."
                    } else if (draft.id.isBlank()) "Add" else "Save",
                    onClick = {
                        if (!isSaving) {
                            hasSubmitted = true
                            if (!validateParentEditor(draft).hasAnyError) onSave(draft)
                        }
                    },
                    style = AppDialogActionStyle.Primary,
                    enabled = !isSaving,
                    width = 150.dp
                )
            ),
            colors = ParentsDialogColors,
            contentPadding = PaddingValues(horizontal = 20.dp),
            footerHeight = 80.dp
        )
    }
}

private fun ParentStudentOptionUi.toParentEditorDraft(current: ParentEditorDraft): ParentEditorDraft {
    val activeParents = parents.filter { it.isActive != false }
    val primary = activeParents.firstOrNull { it.isPrimaryContact == true } ?: activeParents.firstOrNull()
    val secondary = activeParents.firstOrNull { it !== primary }
    return current.copy(
        id = primary?.parentId.orEmpty(),
        selectedStudentId = id,
        selectedStudentLabel = "$admissionNo | $studentName | Class $className-$section | Roll No. $rollNo",
        studentSearchQuery = "",
        primaryContactName = primary?.name.orEmpty(),
        primaryContactMobile = primary?.mobile.orEmpty(),
        primaryContactEmail = primary?.email.orEmpty(),
        primaryRelationshipCode = primary?.relationshipType.orEmpty().ifBlank { SchoolKeys.V_REL_FATHER },
        secondaryContactName = secondary?.name.orEmpty(),
        secondaryContactMobile = secondary?.mobile.orEmpty(),
        secondaryContactEmail = secondary?.email.orEmpty(),
        secondaryRelationshipCode = secondary?.relationshipType.orEmpty().ifBlank { SchoolKeys.V_REL_MOTHER },
        statusCode = SchoolKeys.V_STATUS_ACTIVE,
        primaryLinkId = primary?.linkId.orEmpty(),
        secondaryParentId = secondary?.parentId.orEmpty(),
        secondaryLinkId = secondary?.linkId.orEmpty()
    )
}

@Composable
private fun ParentStudentSelectorField(
    label: String,
    selectedStudentId: String,
    selectedLabel: String,
    expanded: Boolean,
    query: String,
    students: List<ParentStudentOptionUi>,
    isLoading: Boolean,
    isLoadingMore: Boolean,
    hasMore: Boolean,
    loadError: String,
    onStudentPickerLoadMore: () -> Unit,
    onToggleExpanded: () -> Unit,
    onDismissExpanded: () -> Unit,
    onQueryChange: (String) -> Unit,
    onClearSelection: () -> Unit,
    onSelectStudent: (ParentStudentOptionUi) -> Unit,
    error: String = ""
) {
    var anchorSize by remember { mutableStateOf(IntSize.Zero) }
    val popupWidth = with(LocalDensity.current) { anchorSize.width.toDp() }
    val listState = rememberLazyListState()
    LaunchedEffect(expanded, listState, students.size, hasMore, isLoadingMore) {
        if (expanded) {
            snapshotFlow { listState.layoutInfo.visibleItemsInfo.lastOrNull()?.index ?: -1 }
                .distinctUntilChanged()
                .collectLatest { lastVisible ->
                    if (hasMore && students.isNotEmpty() && lastVisible >= students.lastIndex - 1) onStudentPickerLoadMore()
                }
        }
    }

    AppDialogFieldColumn(
        label = label.replace(" *", "").replace("*", "").trim(),
        required = label.contains("*"),
        error = error,
        colors = ParentsDialogColors
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .onGloballyPositioned { anchorSize = it.size }
        ) {
            Surface(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(58.dp)
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = onToggleExpanded
                    ),
                shape = RoundedCornerShape(8.dp),
                color = ParentsSurface,
                border = androidx.compose.foundation.BorderStroke(
                    1.dp,
                    when {
                        error.isNotBlank() -> ParentsDialogColors.danger
                        expanded -> ParentsPrimary
                        else -> ParentsBorder
                    }
                )
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(horizontal = 18.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        modifier = Modifier.weight(1f),
                        horizontalArrangement = Arrangement.spacedBy(12.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            painter = painterResource(Res.drawable.search),
                            contentDescription = null,
                            tint = ParentsMuted,
                            modifier = Modifier.size(18.dp)
                        )
                        Text(
                            text = selectedLabel.ifBlank { "Search student" },
                            color = if (selectedLabel.isBlank()) ParentsMuted else ParentsNavy,
                            fontSize = 15.sp,
                            fontWeight = FontWeight.Medium,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                        if (selectedStudentId.isNotBlank()) {
                            Icon(
                                painter = painterResource(Res.drawable.close_x),
                                contentDescription = "Clear selection",
                                tint = ParentsMuted,
                                modifier = Modifier
                                    .size(18.dp)
                                    .clickable(onClick = onClearSelection)
                            )
                        }
                        Icon(
                            painter = painterResource(Res.drawable.chevron_down),
                            contentDescription = null,
                            tint = ParentsNavy,
                            modifier = Modifier.size(18.dp)
                        )
                    }
                }
            }

            if (expanded) {
                Popup(
                    popupPositionProvider = parentStudentPopupPositionProvider(),
                    properties = PopupProperties(
                        focusable = true,
                        dismissOnBackPress = true,
                        dismissOnClickOutside = true
                    ),
                    onDismissRequest = onDismissExpanded
                ) {
                    Surface(
                        modifier = Modifier.width(popupWidth),
                        shape = RoundedCornerShape(12.dp),
                        color = ParentsSurface,
                        shadowElevation = 16.dp,
                        border = androidx.compose.foundation.BorderStroke(1.dp, ParentsBorder)
                    ) {
                        Column(modifier = Modifier.fillMaxWidth()) {
                            StudentPopupHeader()
                            HorizontalDivider(color = ParentsLine)
                            if (isLoading && students.isEmpty()) {
                                Box(Modifier.fillMaxWidth().height(100.dp), contentAlignment = Alignment.Center) {
                                    androidx.compose.material3.CircularProgressIndicator(modifier = Modifier.size(22.dp), strokeWidth = 2.dp)
                                }
                            } else if (loadError.isNotBlank() && students.isEmpty()) {
                                Text(loadError, color = ParentsDanger, fontSize = 14.sp, modifier = Modifier.padding(18.dp))
                            } else if (students.isEmpty()) {
                                Text(
                                    text = if (query.trim().length == 1) "Type at least 2 characters to search" else "No matching students found.",
                                    color = ParentsMuted,
                                    fontSize = 14.sp,
                                    fontWeight = FontWeight.Medium,
                                    modifier = Modifier.padding(horizontal = 18.dp, vertical = 14.dp)
                                )
                            } else {
                                LazyColumn(
                                    state = listState,
                                    modifier = Modifier.fillMaxWidth().heightIn(max = 260.dp)
                                ) {
                                    items(students, key = { it.id }) { student ->
                                        StudentPopupRow(
                                            student = student,
                                            selected = student.id == selectedStudentId,
                                            onClick = {
                                                onSelectStudent(student)
                                                onDismissExpanded()
                                            }
                                        )
                                    }
                                    if (isLoadingMore) {
                                        item {
                                            Box(Modifier.fillMaxWidth().padding(10.dp), contentAlignment = Alignment.Center) {
                                                androidx.compose.material3.CircularProgressIndicator(modifier = Modifier.size(18.dp), strokeWidth = 2.dp)
                                            }
                                        }
                                    }
                                }
                            }
                            HorizontalDivider(color = ParentsLine)
                            StudentPopupSearchField(
                                value = query,
                                onValueChange = onQueryChange,
                                onClear = { onQueryChange("") },
                                placeholder = "Type at least 2 characters to search"
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun StudentPopupHeader() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = 18.dp, vertical = 12.dp),
        horizontalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Text("Admission No.", modifier = Modifier.weight(0.8f), fontSize = 12.sp, fontWeight = FontWeight.SemiBold, color = ParentsMuted)
        Text("Student Name", modifier = Modifier.weight(1.4f), fontSize = 12.sp, fontWeight = FontWeight.SemiBold, color = ParentsMuted)
        Text("Class - Section", modifier = Modifier.weight(1.0f), fontSize = 12.sp, fontWeight = FontWeight.SemiBold, color = ParentsMuted)
        Text("Roll No.", modifier = Modifier.weight(0.7f), fontSize = 12.sp, fontWeight = FontWeight.SemiBold, color = ParentsMuted)
    }
}

@Composable
private fun StudentPopupRow(
    student: ParentStudentOptionUi,
    selected: Boolean,
    onClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(if (selected) ParentsSelectBg else Color.Transparent)
            .clickable(onClick = onClick)
            .padding(horizontal = 18.dp, vertical = 11.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(16.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(student.admissionNo, modifier = Modifier.weight(0.8f), color = ParentsNavy, fontSize = 14.sp, fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium)
            Text(student.studentName, modifier = Modifier.weight(1.4f), color = ParentsNavy, fontSize = 14.sp, fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium, maxLines = 1, overflow = TextOverflow.Ellipsis)
            Text("${student.className} - ${student.section}", modifier = Modifier.weight(1.0f), color = ParentsNavy, fontSize = 14.sp, fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium)
            Text(student.rollNo, modifier = Modifier.weight(0.7f), color = ParentsNavy, fontSize = 14.sp, fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium)
        }
    }
}

@Composable
private fun StudentPopupSearchField(
    value: String,
    onValueChange: (String) -> Unit,
    onClear: () -> Unit,
    placeholder: String
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(54.dp)
            .padding(horizontal = 18.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.dp)
    ) {
        Icon(
            painter = painterResource(Res.drawable.search),
            contentDescription = null,
            tint = ParentsMuted,
            modifier = Modifier.size(18.dp)
        )
        BasicTextField(
            value = value,
            onValueChange = onValueChange,
            singleLine = true,
            textStyle = TextStyle(
                fontSize = 15.sp,
                fontWeight = FontWeight.Medium,
                color = ParentsNavy
            ),
            cursorBrush = SolidColor(com.schoolconnect.app.designsystem.AppPrimary),
            modifier = Modifier.weight(1f)
        ) { innerTextField ->
            Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.CenterStart) {
                if (value.isBlank()) {
                    Text(
                        text = placeholder,
                        color = ParentsMuted,
                        fontSize = 15.sp,
                        fontWeight = FontWeight.Medium,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
                innerTextField()
            }
        }
        if (value.isNotBlank()) {
            Icon(
                painter = painterResource(Res.drawable.close_x),
                contentDescription = "Clear search",
                tint = ParentsMuted,
                modifier = Modifier
                    .size(18.dp)
                    .clickable(onClick = onClear)
            )
        }
    }
}

private fun parentStudentPopupPositionProvider(verticalGap: Int = 8): PopupPositionProvider {
    return object : PopupPositionProvider {
        override fun calculatePosition(
            anchorBounds: IntRect,
            windowSize: IntSize,
            layoutDirection: androidx.compose.ui.unit.LayoutDirection,
            popupContentSize: IntSize
        ): IntOffset {
            val x = anchorBounds.left.coerceIn(0, (windowSize.width - popupContentSize.width).coerceAtLeast(0))
            val belowY = anchorBounds.bottom + verticalGap
            val aboveY = anchorBounds.top - popupContentSize.height - verticalGap
            val y = if (belowY + popupContentSize.height <= windowSize.height) belowY else aboveY.coerceAtLeast(0)
            return IntOffset(x, y)
        }
    }
}

@Composable
private fun SelectedStudentSummary(student: ParentStudentOptionUi) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = ParentsInfoBg),
        border = androidx.compose.foundation.BorderStroke(1.dp, ParentsInfoBorder),
        shape = RoundedCornerShape(10.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(16.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Box(
                modifier = Modifier
                    .size(66.dp)
                    .background(ParentsPrimarySoft, CircleShape),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = painterResource(Res.drawable.users),
                    contentDescription = null,
                    tint = ParentsPrimary,
                    modifier = Modifier.size(30.dp)
                )
            }
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    Text("Admission No.:", fontWeight = FontWeight.Bold, color = ParentsNavy)
                    Text(student.admissionNo, fontWeight = FontWeight.Medium, color = ParentsNavy)
                }
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    Text("Student Name:", fontWeight = FontWeight.Bold, color = ParentsNavy)
                    Text(student.studentName, fontWeight = FontWeight.Medium, color = ParentsNavy)
                }
            }
            Spacer(modifier = Modifier.weight(1f))
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    Text("Class - Section:", fontWeight = FontWeight.Bold, color = ParentsNavy)
                    Text("${student.className} - ${student.section}", fontWeight = FontWeight.Medium, color = ParentsNavy)
                }
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    Text("Roll No.:", fontWeight = FontWeight.Bold, color = ParentsNavy)
                    Text(student.rollNo, fontWeight = FontWeight.Medium, color = ParentsNavy)
                }
            }
        }
    }
}

@Composable
private fun ParentDetailsDialog(
    parent: ParentRowUi,
    onDismiss: () -> Unit
) {
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Standard,
        colors = ParentsDialogColors,
        fillDialogHeight = true
    ) {
        AppDialogHeader(
            title = "View Parent",
            subtitle = "",
            onClose = onDismiss,
            colors = ParentsDialogColors,
            height = 112.dp
        )
        HorizontalDivider(color = ParentsLine)
        AppDialogBody(
            colors = ParentsDialogColors,
            horizontalPadding = 24.dp,
            compactHorizontalPadding = 18.dp,
            verticalPadding = 18.dp
        ) {
            InfoStrip(parent)
            SectionCard(
                title = "Student Information",
                leadingIcon = Res.drawable.users
            ) {
                DetailGrid(
                    listOf(
                        "Admission No." to parent.admissionNo,
                        "Student Name" to parent.studentName,
                        "Class" to parent.className,
                        "Section" to parent.section,
                        "Roll No." to parent.rollNo
                    )
                )
                val additionalLinkedStudents = parent.linkedStudents
                    .filterNot { student ->
                        (student.studentId.isNotBlank() && student.studentId == parent.studentId) ||
                            (student.admissionNo.isNotBlank() && student.admissionNo == parent.admissionNo)
                    }
                    .distinctBy { it.studentId }
                if (additionalLinkedStudents.isNotEmpty()) {
                    Spacer(modifier = Modifier.height(4.dp))
                    Text(
                        text = "Linked Students",
                        color = ParentsNavy,
                        fontWeight = FontWeight.ExtraBold,
                        fontSize = 15.sp
                    )
                    Spacer(modifier = Modifier.height(4.dp))
                    Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                        additionalLinkedStudents.forEach { student ->
                            LinkedStudentSummaryRow(student)
                        }
                    }
                }
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    Text("Status", modifier = Modifier.weight(0.35f), color = ParentsMuted, fontWeight = FontWeight.SemiBold, fontSize = 14.sp)
                    Text(":", modifier = Modifier.weight(0.06f), color = ParentsMuted, fontSize = 14.sp)
                    Box(modifier = Modifier.weight(0.59f), contentAlignment = Alignment.CenterStart) {
                        ParentStatusBadge(statusCode = parent.statusCode)
                    }
                }
            }
            SectionCard(
                title = "Parent / Guardian Information",
                leadingIcon = Res.drawable.users
            ) {
                ContactSummaryLine("Primary Contact", parentPrimarySummary(parent))
                HorizontalDivider(color = ParentsLine)
                ContactSummaryLine("Secondary Contact", parentSecondarySummary(parent))
            }
        }
        HorizontalDivider(color = ParentsLine)
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction(label = "Close", onClick = onDismiss, width = 170.dp)
            ),
            colors = ParentsDialogColors,
            contentPadding = PaddingValues(horizontal = 20.dp),
            footerHeight = 80.dp
        )
    }
}

@Composable
private fun InfoStrip(parent: ParentRowUi) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = ParentsSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ParentsBorder),
        shape = RoundedCornerShape(10.dp)
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(24.dp), verticalAlignment = Alignment.CenterVertically) {
                MetaInfo(label = "Created By:", value = parent.createdBy, icon = Res.drawable.users, modifier = Modifier.weight(1f))
                MetaInfo(label = "Created Date:", value = parent.createdAtText, icon = Res.drawable.calendar, modifier = Modifier.weight(1f))
            }
            Row(horizontalArrangement = Arrangement.spacedBy(24.dp), verticalAlignment = Alignment.CenterVertically) {
                MetaInfo(label = "Updated By:", value = parent.updatedBy, icon = Res.drawable.users, modifier = Modifier.weight(1f))
                MetaInfo(label = "Updated Date:", value = parent.updatedAtText, icon = Res.drawable.calendar, modifier = Modifier.weight(1f))
            }
        }
    }
}

@Composable
private fun MetaInfo(
    label: String,
    value: String,
    icon: org.jetbrains.compose.resources.DrawableResource,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Box(
            modifier = Modifier
                .size(42.dp)
                .background(ParentsPrimarySoft, CircleShape),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(icon),
                contentDescription = null,
                tint = ParentsPrimary,
                modifier = Modifier.size(22.dp)
            )
        }
        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(2.dp)
        ) {
            Text(
                text = label,
                color = ParentsMuted,
                fontWeight = FontWeight.SemiBold,
                fontSize = 14.sp
            )
            Text(
                text = value.ifBlank { "-" },
                color = ParentsNavy,
                fontWeight = FontWeight.Medium,
                fontSize = 14.sp
            )
        }
    }
}

@Composable
private fun SectionCard(
    title: String,
    leadingIcon: org.jetbrains.compose.resources.DrawableResource,
    content: @Composable ColumnScope.() -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = ParentsSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ParentsBorder),
        shape = RoundedCornerShape(10.dp)
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(18.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Icon(
                    painter = painterResource(leadingIcon),
                    contentDescription = null,
                    tint = ParentsPrimary,
                    modifier = Modifier.size(22.dp)
                )
                Text(title, color = ParentsPrimary, fontWeight = FontWeight.ExtraBold, fontSize = 16.sp)
            }
            HorizontalDivider(color = ParentsLine)
            content()
        }
    }
}

@Composable
private fun DetailGrid(items: List<Pair<String, String>>) {
    Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
        items.forEach { (label, value) ->
            Row(verticalAlignment = Alignment.Top, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Text(label, modifier = Modifier.weight(0.35f), color = ParentsMuted, fontWeight = FontWeight.SemiBold, fontSize = 14.sp)
                Text(":", modifier = Modifier.weight(0.06f), color = ParentsMuted, fontSize = 14.sp)
                Text(value.ifBlank { "-" }, modifier = Modifier.weight(0.59f), color = ParentsNavy, fontWeight = FontWeight.Medium, fontSize = 14.sp)
            }
        }
    }
}

@Composable
private fun ContactSummaryLine(label: String, summary: String) {
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(label, color = ParentsNavy, fontWeight = FontWeight.ExtraBold, fontSize = 16.sp)
        Row(horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) {
            Text(summary.ifBlank { "-" }, color = ParentsNavy, fontWeight = FontWeight.Medium, fontSize = 14.sp)
        }
    }
}

@Composable
private fun LinkedStudentSummaryRow(student: ParentLinkedStudentUi) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(ParentsSelectBg, RoundedCornerShape(8.dp))
            .padding(horizontal = 12.dp, vertical = 10.dp),
        verticalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
            Text(
                text = student.admissionNo.ifBlank { "-" },
                color = ParentsPrimary,
                fontWeight = FontWeight.ExtraBold,
                fontSize = 13.sp
            )
            Text(
                text = "${student.className.ifBlank { "-" }}-${student.section.ifBlank { "-" }}",
                color = ParentsMuted,
                fontWeight = FontWeight.SemiBold,
                fontSize = 13.sp
            )
            if (student.isPrimaryContact) {
                ParentStatusBadge(statusCode = SchoolKeys.V_STATUS_ACTIVE)
            }
        }
        Text(
            text = student.studentName.ifBlank { "-" },
            color = ParentsNavy,
            fontWeight = FontWeight.Medium,
            fontSize = 14.sp,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        if (student.relationshipType.isNotBlank()) {
            Text(
                text = "Relationship: ${parentRelationshipLabel(student.relationshipType)}",
                color = ParentsMuted,
                fontWeight = FontWeight.Medium,
                fontSize = 12.sp
            )
        }
    }
}

@Composable
private fun SectionHeader(title: String) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(title, color = ParentsNavy, fontWeight = FontWeight.ExtraBold, fontSize = 16.sp)
        Spacer(modifier = Modifier.width(12.dp))
        HorizontalDivider(color = ParentsLine, modifier = Modifier.weight(1f))
    }
}

@Composable
private fun ParentTextField(
    label: String,
    value: String,
    placeholder: String,
    leadingIcon: Any,
    onValueChange: (String) -> Unit,
    error: String = "",
    trailingClearVisible: Boolean = false,
    onClear: (() -> Unit)? = null
) {
    val cleanLabel = label.replace(" *", "").replace("*", "").trim()
    AppDialogFieldColumn(
        label = cleanLabel,
        required = label.contains("*"),
        error = error,
        colors = ParentsDialogColors
    ) {
        AppDialogTextField(
            value = value,
            onValueChange = onValueChange,
            placeholder = placeholder,
            colors = ParentsDialogColors,
            error = error,
            fontSize = 15.sp,
            leadingIcon = {
                Icon(
                    painter = painterResource(leadingIcon as org.jetbrains.compose.resources.DrawableResource),
                    contentDescription = null,
                    tint = ParentsMuted,
                    modifier = Modifier.size(18.dp)
                )
            },
            trailingIcon = if (trailingClearVisible && onClear != null) {
                {
                    IconButton(onClick = onClear) {
                        Icon(
                            painter = painterResource(Res.drawable.close_x),
                            contentDescription = "Clear",
                            tint = ParentsMuted
                        )
                    }
                }
            } else null
        )
    }
}

@Composable
private fun ParentDateField(
    label: String,
    value: String,
    placeholder: String,
    onValueChange: (String) -> Unit
) {
    val cleanLabel = label.replace(" *", "").replace("*", "").trim()
    AppDialogFieldColumn(
        label = cleanLabel,
        required = label.contains("*"),
        colors = ParentsDialogColors
    ) {
        AppDialogDateField(
            value = value,
            onValueChange = onValueChange,
            placeholder = placeholder,
            colors = ParentsDialogColors,
            fontSize = 15.sp
        )
    }
}

@Composable
private fun ParentDropdownField(
    label: String,
    value: String,
    items: List<Any>,
    onSelected: (String) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    val cleanLabel = label.replace(" *", "").replace("*", "").trim()
    val options = items.map {
        when (it) {
            is Pair<*, *> -> it.second?.toString().orEmpty()
            else -> it.toString()
        }
    }
    val optionMap = items.mapNotNull {
        when (it) {
            is Pair<*, *> -> it.first?.toString()?.let { code -> code to it.second?.toString().orEmpty() }
            is String -> it to it
            else -> null
        }
    }
    val selectedValue = value.ifBlank { label.substringBefore(" *").ifBlank { "Select" } }

    AppDialogFieldColumn(
        label = cleanLabel,
        required = label.contains("*"),
        colors = ParentsDialogColors
    ) {
        AppDialogSelectField(
            value = selectedValue,
            placeholder = selectedValue,
            expanded = expanded,
            options = options,
            onToggleExpanded = { expanded = true },
            onDismissExpanded = { expanded = false },
            onSelected = { selected ->
                expanded = false
                val matched = optionMap.firstOrNull { it.second == selected }?.first ?: selected
                onSelected(matched)
            },
            colors = ParentsDialogColors,
            fontSize = 15.sp
        )
    }
}

@Composable
private fun DualFilterRow(
    left: @Composable () -> Unit,
    right: @Composable () -> Unit
) {
    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
        Box(modifier = Modifier.weight(1f)) { left() }
        Box(modifier = Modifier.weight(1f)) { right() }
    }
}

private fun buildClassSectionLabel(className: String, section: String): String =
    listOf(className.trim(), section.trim())
        .mapNotNull { it.takeIf { value -> value.isNotBlank() } }
        .joinToString("-")

private fun ParentRowUi.toEditorDraft(): ParentEditorDraft = ParentEditorDraft(
    id = id,
    selectedStudentId = studentId,
    selectedStudentLabel = "$admissionNo | $studentName | Class $className-$section | Roll No. $rollNo",
    primaryContactName = primaryContactName,
    primaryContactMobile = primaryContactMobile,
    primaryContactEmail = primaryContactEmail,
    primaryRelationshipCode = primaryRelationshipCode,
    secondaryContactName = secondaryContactName,
    secondaryContactMobile = secondaryContactMobile,
    secondaryContactEmail = secondaryContactEmail,
    secondaryRelationshipCode = secondaryRelationshipCode,
    statusCode = statusCode,
    primaryLinkId = primaryLinkId,
    secondaryParentId = secondaryParentId,
    secondaryLinkId = secondaryLinkId
)

private fun String.relationshipDisplay(): String = when (this) {
    SchoolKeys.V_REL_FATHER -> "Father"
    SchoolKeys.V_REL_MOTHER -> "Mother"
    SchoolKeys.V_REL_GUARDIAN -> "Guardian"
    else -> when (this.trim().lowercase()) {
        "father" -> "Father"
        "mother" -> "Mother"
        "guardian" -> "Guardian"
        else -> this.ifBlank { "Select Relationship" }
    }
}

